module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Navigation/Left-2-6325d003b592e22da2ee3ea24b41f079.svg";